import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";

export default function ConfirmPopUp({
  dialog,
  setDialog,
  formData,
  handleFreeze,
  loading,
}) {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={dialog}
      onClose={() => setDialog(false)}
    >
      <DialogTitle style={{ fontWeight: 700, fontSize: "17px" }}>
        Generate API
      </DialogTitle>
      <DialogContent>
        <Typography fontSize={"15px"}>
          Are you sure you want to generate API?
        </Typography>
      </DialogContent>

      <DialogActions>
        <CancelButton variant="outlined" onClick={() => setDialog(false)}>
          Cancel
        </CancelButton>

        <PrimaryLoadingButton
          loading={loading}
          onClick={handleFreeze}
          variant="contained"
        >
          Generate API
        </PrimaryLoadingButton>
      </DialogActions>
    </Dialog>
  );
}
